import Vue from 'vue';
import store from './store.js';
import { datetime } from "./store_utils.js";

export const cz = {
  "tent": "Stan",
  "hut": "Chatka",
  "cottage": "Chata",
  "hotel": "Hotel",
  "hotel_wc": "Hotel se sociálkami",
  "special": "Speciál",

  "kids": "Kids",
  "discovery": "Discovery",
  "adventure": "Adventure",
  "expedition": "Expedition",
  "expedition_restful": "Expedition - rekreační",
  "expedition_profi": "Expedition - profi",
  "royalRanger": "Royal Ranger",
  "royalRanger_restful": "Royal Ranger - rekreační",
  "royalRanger_profi": "Royal Ranger - profi",
  "senior": "Senior",
  "woman": "Ženy",

  "servant": "Služebník",
  "volunteer": "Dobrovolník",
  "judge": "Rozhodčí",
  "spiritualGuide": "Duchovní poradce",

  "participant": "Účastník",
  "participants": "Účastníci",
  "accommodation": "Ubytování",
  "accommodationOrders": "Objednané ubytování",
  "dashboard": "Přehled",
  "teams": "Ringo",
  "larp_teams": "LARP",
  "boardgames": "Deskovky",
  "more": "Další",
  "activities": "Doprovodné programy",
  "tournament": "Turnaj",
  "fields": "Hřiště",
  "pays": "Platby",
  "modifiers": "Slevy & přirážky",
  "buses": "Autobusy",
  "waves": "Vlny",
  "users": "Uživatelé",
  "outposts": "Hlídky",
  "servants": "Služebníci",
  "ages": "Období",
  "config": "Nastavení",
  "myMatches": "Moje zápasy",
  "freeMatches": "Volné zápasy",
  "allMatches": "Všechny zápasy",
  "map": "Mapa",

  "User": "Velitel",
  "Finance": "Účetní",
  "Judge": "Rozhodčí",
  "Admin": "Organizátor",

  "TrainToCamp": "Na turnaj",
  "CampToTrain": "Z turnaje",

  "Male": "Muž",
  "Female": "Žena",
  
  "RoundRobin": "Skupiny",
  "MiddleRoundRobin": "Postupové skupiny",
  "Elimination": "Pavouk",

  "Winner": "Vítěz",
  "Looser": "Prohra",
};
export const cz_short = {
  kids: 'RK',
  discovery: 'DR',
  adventure: 'AR',
  expedition: 'ER',
  expedition_restful: "ER-R",
  expedition_profi: "ER-P",
  royalRanger: 'RR',
  royalRanger_restful: "RR-R",
  royalRanger_profi: "RR-P",
  senior: 'SR',
  woman: 'Z',
  ADVANCING: "Postup",
};

export default {
  init() {
    Vue.filter('emptyOrName', value => {
      if (value == null)
        return "";

      return value.name;
    });
    // cz
    Vue.filter('cz_boolean', value => {
      return value ? "ano" : "ne";
    });
    Vue.filter('cz_date', value => {
      if (value == null)
        return null;

      return value.toLocaleDateString("cs-CZ");
    });
    Vue.filter('cz_datetime', value => {
      if (value == null)
        return null;

      return datetime.datetimeToCzechString(value);
    });
    Vue.filter('currency', value => {
      return value + ' Kč'
    });

    // enums cz
    Vue.filter('cz', value => {
      if (value instanceof Date)
        return datetime.datetimeToCzechString(value);

      const result = cz[value];
      if (result != null)
        return result;

      return value;
    });

    Vue.filter('cz_healthProblemLong', value => {
      switch (value) {
        case "None":
          return "Žádné";
        case "Allergy":
          return "Alergie/anafylaktické reakce (hmyz, potraviny) (A)";
        case "Asthma": 
          return "Astma (B)";
        case "HeartDisease":
          return "Kardiaci - těžcí (operace/medikovaní) (C)";
        case "Epilepsy": 
          return "Epilepsie (E)";
        case "Diabetes": 
          return "Diabetici (D)";
        case "GluttenFreeDiet": 
          return "Bezlepková strava (G)";
        case "LactoseFreeDiet":
          return "Bezlaktózová strava (H)";
        case "Other": 
          return "Jiné (F)";
        default:
          return cz[value];
      }
    });
    Vue.filter('cz_healthProblemShort', value => {
      switch (value) {
        case "None":
          return "-";
        case "Allergy":
          return "A";
          case "Asthma": 
            return "B";
        case "HeartDisease":
          return "C";
        case "Epilepsy": 
          return "E";
        case "Diabetes": 
          return "D";
        case "GluttenFreeDiet": 
          return "G";
        case "LactoseFreeDiet":
          return "H";
        case "Other": 
          return "F";
        default:
          return cz[value];
      }
    });

    // accommodation
    Vue.filter('cz_beds', value => {
      if (value == 0 || value >= 5)
        return `${value} lůžek`;
      if (value == 1)
        return "1 lůžko";
      // 2-4
      return `${value} lůžka`;
    });

    Vue.filter('cz_accommodation', value => {
      var parts = value.split('-');
      switch (parts[0]) {
        case 'tent': return cz.tent;
        case 'hut': return `${cz.hut} č. ${parts[1]}`;
        case 'cottage': return `${cz.cottage} č. ${parts[1]}, pokoj ${parts[2]}`;
        case 'hotel': return `${cz.hotel}, pokoj ${parts[1]}`;
        case 'hotel_wc': return `${cz.hotel_wc}, pokoj ${parts[1]}`;
        case 'special': return `Klubovna místnost č. ${parts[1]}-${parts[2]}`;
        default: return value;
      }
    });

    // shirt sizes
    Vue.filter('cz_size', value => {
      var parts = value.split('_');
      switch (parts[0]) {
        case 'child':
          return `Dětské ${parts[1]}/${parts[2]} let`;
        case 'woman':
          return `Dámské ${parts[1].toUpperCase()}`;
        case 'man':
          return `Pánské ${parts[1].toUpperCase()}`;
        default:
          return value;
      }
    });

    // participant
    Vue.filter('participant_name', participant => {
      if (participant === undefined || participant == null)
        return "Žádný";

      var result = participant.name + ' ' + participant.surname;

      // foreigner
      if (participant.playingOutpostId != store.state.outpost.id)
        result = participant.playingOutpostId + '. PH: ' + result;

      return result;
    });

    Vue.filter('participant_partilyDays', date => {
      let nextDay = new Date(date);
      nextDay.setDate(date.getDate() + 1);
      return `${date.toLocaleDateString("cs-CZ", { weekday: "short" })} - ${nextDay.toLocaleDateString("cs-CZ", { weekday: "short" })}`;
    });

    // team
    Vue.filter('team_name_full', team => {
      if (team == null || team.id == null)
        return team;

      var splitted = team.id.split('-');
      const name = `${cz_short[splitted[0]]}-${splitted[1]}`;

      if (team.outpostId != null && team.outpostId != store.state.outpost.id)
        return `${name} (${team.outpostId}.PH)`;

      return name;
    });
    Vue.filter('team_name_short', teamId => {
      if (teamId == null)
        return teamId;

      var splitted = teamId.split('-');
      const name = cz_short[splitted[0]] + '-' + splitted[1];

      return name;
    });
    
    Vue.filter('larp_team_name_full', team => {
      if (team == null || team.id == null || team.outpostId == null)
        return team;

      var splitted = team.id.split('-');
      const name = `L-${cz_short[splitted[1]]}-${splitted[2]}`;

      if (team.outpostId != store.state.outpost.id)
        return `${name} (${team.outpostId}.PH)`;

      return name;
    });
    Vue.filter('larp_team_name_short', teamId => {
      if (teamId == null)
        return teamId;

      var splitted = teamId.split('-');
      const name = `L-${cz_short[splitted[1]]}-${splitted[2]}`;

      return name;
    });

    Vue.filter('bracket_team_name_a', ({ bracketTeamA, teamA, sourceBracketA, sourceMatchA }) => {
      // concrete team (roundRobin || running elimination)
      if (teamA != null) {
        return Vue.filter('team_name_full')(teamA);
      }
      
      // roundRobin to elimination
      if (sourceMatchA != null && bracketTeamA != null && bracketTeamA.advancingOrder != null) {
        return `${bracketTeamA.advancingOrder}. z ${sourceMatchA.name}`;
      }

      // elimination
      if (bracketTeamA != null && sourceMatchA != null) {
        return `${cz[bracketTeamA.resultType]} ze zápasu ${sourceMatchA.order}`;
      }

      // missing data
      return "---";
    });
    Vue.filter('bracket_team_name_b', ({ bracketTeamB, teamB, sourceBracketB, sourceMatchB }) => {
      // concrete team (roundRobin || running elimination)
      if (teamB != null) {
        return Vue.filter('team_name_full')(teamB);
      }
      
      // roundRobin to elimination
      if (sourceMatchB != null && bracketTeamB != null && bracketTeamB.advancingOrder != null) {
        return `${bracketTeamB.advancingOrder}. z ${sourceMatchB.name}`;
      }

      // elimination
      if (bracketTeamB != null && sourceMatchB != null) {
        return `${cz[bracketTeamB.resultType]} ze zápasu ${sourceMatchB.order}`;
      }

      // missing data
      return "---";
    });

    // activities
    Vue.filter('activity_scope', dayPart => {
      return `${dayPart.toLocaleDateString("cs-CZ", { weekday: "short" })} - ${dayPart.getHours() == 0 ? 'dopoledne' : 'odpoledne'}`;
    });
    Vue.filter('activity_scopes', dayParts => {
      if (dayParts.length == 0)
        return "Nic";
      
      return dayParts.map(i => `${i.toLocaleDateString("cs-CZ", { weekday: "short" })} - ${i.getHours() == 0 ? 'do' : 'od'}`).join(', ');
    });
  }
};